import Vue from 'vue';
import App from './App.vue';

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

Vue.use(Vuetify);
Vue.use(VuePlyr);

const opts = {};

let vuetify = new Vuetify(opts);

new Vue({
    vuetify,
    render: createElement => createElement(App)
}).$mount('#app');